<p class="post__block post__paragraph" v-html="htmlTextWithTargetBlank"></p>
